import React, { FC } from 'react';

import { getImageUrlBySize, transformImage } from '@/shared/lib/images';

import { useReadChannelPlayerBaseInfo } from '../../components/channel-player/hooks/use-read-channel-player-base-info';
import { ChannelProgramModalHeader } from '../../components/ChannelProgramModalHeader/ChannelProgramModalHeader';

interface Props {
    channelId: string;
}

const ChannelProgramModalHeaderContainer: FC<Props> = ({ channelId }) => {
    const baseInfo = useReadChannelPlayerBaseInfo(channelId);
    const horizontalPoster = transformImage(baseInfo?.gallery.covers.horizontal);
    const posterUrl = transformImage(baseInfo?.gallery.logos.main);
    const title = baseInfo?.title ?? '';

    return (
        <ChannelProgramModalHeader
            title={title}
            img={getImageUrlBySize(horizontalPoster || posterUrl, '720x360')}
        />
    );
};

export default React.memo(ChannelProgramModalHeaderContainer);
